import { createFileRoute } from "@tanstack/react-router";
import { EmailSentScreen } from "#app/components/auth/email-sent-screen";
import { requestPasswordReset } from "#app/lib/auth-service";

function ResetPasswordSentScreen() {
  const { email } = Route.useSearch();
  return (
    <EmailSentScreen
      subheading={`We've sent a password reset link to ${email}`}
      onResend={email ? () => requestPasswordReset(email) : undefined}
    />
  );
}

export const Route = createFileRoute("/(auth)/reset-password-sent")({
  validateSearch: (search: Record<string, unknown>): { email: string } => ({
    email: typeof search.email === "string" ? search.email : "",
  }),
  component: ResetPasswordSentScreen,
});
